// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"color-picker_tooltip__2bZpB"};